import {createApi} from '@reduxjs/toolkit/query/react';
import {customAxiosBaseQuery} from '../../API/customAxiosBaseQuery';
import {storeReportAPI} from '../../API/api';
import {
	BaseResponseType,
	RequestApproveProductsType,
	ResponseBalanceProductsType,
} from '../../types/TypesStore';
import {
	LoadFinStatProps,
	RequestBalanceProdType,
	RequestGoodsMovementType,
	RequestMovementType,
	ResponseFinBalancePointProducts,
	ResponseFinBalanceProdType,
	ResponseFinLoadStatType,
	ResponseFinPointsType,
	ResponseFinStatType,
	ResponseGoodsMovementType,
	ResponseMovementType,
} from '../../types/StoreReportTypes';

export const depotReportApi = createApi({
	reducerPath: 'depotReportApi',
	baseQuery: customAxiosBaseQuery,
	tagTypes: [
		'balanceProducts',
		'movementsProducts',
		'fin-points',
		'fin-non-points',
		'fin-balance-products',
		'fin-stats',
		'finbalance-point-products',
		'fin-Specnonpoints',
		'fin-Others',
		'fin-Volonter',
	],
	endpoints: (builder) => ({
		getBalanceProducts: builder.query<ResponseBalanceProductsType, void>({
			query: () => ({
				func: storeReportAPI.getBalanceProducts,
				args: [],
			}),
			providesTags: ['balanceProducts'],
		}),
		getBalanceApprove: builder.mutation<
			BaseResponseType,
			RequestApproveProductsType
		>({
			query: (data) => ({
				func: storeReportAPI.getBalanceApprove,
				args: [data],
			}),
			invalidatesTags: ['balanceProducts'],
		}),
		getMovementProducts: builder.query<
			ResponseMovementType,
			RequestMovementType
		>({
			query: (props) => ({
				func: storeReportAPI.getMovementProducts,
				args: [props],
			}),
			providesTags: ['movementsProducts'],
		}),
		getGoodsMovement: builder.query<
			ResponseGoodsMovementType,
			RequestGoodsMovementType
		>({
			query: (props) => ({
				func: storeReportAPI.getGoodsMovement,
				args: [props],
			}),
			providesTags: ['movementsProducts'],
		}),
		getFinPoints: builder.query<ResponseFinPointsType, string>({
			query: (month) => ({
				func: storeReportAPI.getFinPoints,
				args: [month],
			}),
			providesTags: ['fin-points'],
		}),
		getFinNoPoints: builder.query<ResponseFinPointsType, string>({
			query: (month) => ({
				func: storeReportAPI.getFinNoPoints,
				args: [month],
			}),
			providesTags: ['fin-non-points'],
		}),
		getFinSpecnonpoints: builder.query<ResponseFinPointsType, string>({
			query: (month) => ({
				func: storeReportAPI.getFinSpecnonpoints,
				args: [month],
			}),
			providesTags: ['fin-Specnonpoints'],
		}),
		getFinOthers: builder.query<ResponseFinPointsType, string>({
			query: (month) => ({
				func: storeReportAPI.getFinOthers,
				args: [month],
			}),
			providesTags: ['fin-Others'],
		}),
		getFinVolonter: builder.query<ResponseFinPointsType, string>({
			query: (month) => ({
				func: storeReportAPI.getFinVolonter,
				args: [month],
			}),
			providesTags: ['fin-Volonter'],
		}),
		getFinBalanceProducts: builder.query<
			ResponseFinBalanceProdType,
			RequestBalanceProdType
		>({
			query: (data) => ({
				func: storeReportAPI.getFinBalanceProducts,
				args: [data],
			}),
			providesTags: ['fin-balance-products'],
		}),
		getFinStat: builder.query<ResponseFinStatType, RequestBalanceProdType>({
			query: (data) => ({
				func: storeReportAPI.getFinStat,
				args: [data],
			}),
			providesTags: ['fin-stats'],
		}),
		getFinBalancePointProducts: builder.query<
			ResponseFinBalancePointProducts,
			string
		>({
			query: (month) => ({
				func: storeReportAPI.getFinBalancePointProducts,
				args: [month],
			}),
			providesTags: ['finbalance-point-products'],
		}),
		loadFinStat: builder.mutation<ResponseFinLoadStatType, LoadFinStatProps>({
			query: (props) => ({
				func: storeReportAPI.loadFinStat,
				args: [props],
			}),
			invalidatesTags: ['fin-stats'],
		}),
	}),
});

export const {
	useGetBalanceProductsQuery,
	useGetBalanceApproveMutation,
	useGetMovementProductsQuery,
	useGetFinPointsQuery,
	useGetFinNoPointsQuery,
	useGetFinBalanceProductsQuery,
	useGetFinStatQuery,
	useLoadFinStatMutation,
	useGetGoodsMovementQuery,
	useGetFinBalancePointProductsQuery,
	useGetFinVolonterQuery,
	useGetFinOthersQuery,
	useGetFinSpecnonpointsQuery,
} = depotReportApi;
